<template>
    <div class="index">
        <head-nav @result="reserve"></head-nav>
        <left-menu class="leftMenu" :isCollapse='isCollapse'></left-menu>
        <BreadcrumbNav v-bind:class="[isCollapse ? 'BreadcrumbNav':'BreadcrumbNavFull']"></BreadcrumbNav>
        <div v-bind:class="[isCollapse ? 'rightContainer':'rightContainerFull']">
            <router-view></router-view>
        </div>
    </div>
</template>

<script >
    import HeadNav from "../components/HeadNav.vue"
    import LeftMenu from "../components/LeftMenu.vue"
    import BreadcrumbNav from "../components/Breadcrumb.vue"

    export default {
        name: "index",
        components: {
            HeadNav,
            LeftMenu,
            BreadcrumbNav
        },
        data(){
            return {
                isCollapse: false
            }
        },
        mounted(){
            // 初始化
            //this.init()
        },
        methods:{
            reserve(val){
                this.isCollapse = !this.isCollapse
            }
        },
        destroyed () {
        }
    }
</script>

<style lang="scss">
    html, body{
        margin: 0;
        height: 100%;
    }
    .index {
        width: 100%;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        background-color: #EBEEF5;

        .leftMenu{
            position: fixed;
            top: 71px;
            left: 0;
            height: calc(100% - 71px);
            /*min-height: 100%;*/
            background-color: #FFFFFF;
            z-index: 99;
            overflow-y: auto;
        }

        .rightContainer{
            position: relative;
            top: 0;
            left: 60px;
            width: calc(100% - 60px);
            height: calc(100% - 108px);
            overflow: auto;
        }
        .rightContainerFull {
            position: relative;
            top: 0;
            left: 180px;
            width: calc(100% - 180px);
            height: calc(100% - 108px);
            overflow: auto;
        }

        .BreadcrumbNav{
            position: relative;
            top: 0;
            left: 60px;
            height: 35px;
        }
        .BreadcrumbNavFull{
            position: relative;
            top: 0;
            left: 180px;
            height: 35px;
        }
    }
  
</style>
